(() => {
  if (window.CustomProductServicesLoaded) {
    return;
  }

  window.CustomProductServicesLoaded = true;

  class CustomProductServices extends HTMLElement {
    connectedCallback() {
      this.formId = this.dataset.productFormId;
      this.form = document.getElementById(this.formId);

      this.personalizationToggle = this.querySelector(
        "[data-personalization-toggle]"
      );

      this.tasselToggle = this.querySelector(
        "[data-tassel-toggle]"
      );

      this.personalizationText = this.querySelector(
        "[data-personalization-text]"
      );

      this.handleChangeBound = this.handleChange.bind(this);
      this.handleSubmitBound = this.handleSubmit.bind(this);

      this.addEventListener(
        "change",
        this.handleChangeBound
      );

      if (this.form) {
        this.form.addEventListener(
          "submit",
          this.handleSubmitBound,
          true
        );
      }

      /*
       * При першому завантаженні сторінки
       * обидві послуги вимкнені.
       */
      this.syncServiceOption();
    }

    disconnectedCallback() {
      this.removeEventListener(
        "change",
        this.handleChangeBound
      );

      if (this.form) {
        this.form.removeEventListener(
          "submit",
          this.handleSubmitBound,
          true
        );
      }
    }

    /* ==========================================================
       CHANGE
    ========================================================== */

    handleChange(event) {
      /*
       * ========================================================
       * SERVICE CHECKBOX
       * ========================================================
       */

      const toggle = event.target.closest(
        "[data-service-toggle]"
      );

      if (toggle) {
        const service = toggle.closest(
          "[data-service]"
        );

        const content = service?.querySelector(
          "[data-service-content]"
        );

        if (content) {
          content.hidden = !toggle.checked;

          const inputs = content.querySelectorAll(
            "input, select, textarea"
          );

          inputs.forEach((input) => {
            input.disabled = !toggle.checked;

            /*
             * При вимкненні послуги очищаємо
             * її додаткові параметри.
             */
            if (!toggle.checked) {
              if (
                input.type === "radio" ||
                input.type === "checkbox"
              ) {
                input.checked = false;
              } else {
                input.value = "";
              }
            }
          });
        }

        /*
         * Очистити назву кольору китиці,
         * якщо китицю вимкнули.
         */
        if (
          !toggle.checked &&
          service?.dataset.service === "tassel"
        ) {
          const label = service.querySelector(
            "[data-tassel-selected-label]"
          );

          if (label) {
            label.textContent = "";
          }
        }

        /*
         * Головна частина:
         * перемикаємо технічну Shopify option.
         */
        this.syncServiceOption();
      }

      /*
       * ========================================================
       * TASSEL COLOR
       * ========================================================
       */

      if (
        event.target.matches(
          "[data-tassel-color]"
        )
      ) {
        const tassel = event.target.closest(
          '[data-service="tassel"]'
        );

        const label = tassel?.querySelector(
          "[data-tassel-selected-label]"
        );

        if (label) {
          label.textContent =
            event.target.value;
        }
      }

      this.clearError();
    }

    /* ==========================================================
       CURRENT SERVICE VALUE
    ========================================================== */

   getServiceValue() {
  const personalization = Boolean(
    this.personalizationToggle?.checked
  );

  const tassel = Boolean(
    this.tasselToggle?.checked
  );

  if (personalization && tassel) {
    return this.dataset.serviceBothId || null;
  }

  if (personalization) {
    return this.dataset.servicePersonalizationId || null;
  }

  if (tassel) {
    return this.dataset.serviceTasselId || null;
  }

  return this.dataset.serviceNoneId || null;
}

    /* ==========================================================
       FIND SHOPIFY OPTION
    ========================================================== */

   findServiceOptionInput(optionValueId) {
  if (!optionValueId) {
    return null;
  }

  const technicalOption = document.querySelector(
    "variant-picker [data-custom-service-option]"
  );

  if (!technicalOption) {
    console.warn(
      "Custom Product Services: technical service option not found."
    );

    return null;
  }

  const radio = technicalOption.querySelector(
    `input[type="radio"][value="${CSS.escape(String(optionValueId))}"]`
  );

  if (radio) {
    return {
      type: "radio",
      element: radio
    };
  }

  const select = technicalOption.querySelector("select");

  if (select) {
    const option = Array.from(select.options).find(
      (item) =>
        String(item.value) === String(optionValueId)
    );

    if (option) {
      return {
        type: "select",
        element: select,
        option
      };
    }
  }

  console.warn(
    "Custom Product Services: service option value not found:",
    optionValueId
  );

  return null;
}

    /* ==========================================================
       CHANGE TECHNICAL SHOPIFY OPTION
    ========================================================== */

   syncServiceOption() {
  const optionValueId = this.getServiceValue();

  if (!optionValueId) {
    return;
  }

  const control =
    this.findServiceOptionInput(optionValueId);

  if (!control) {
    return;
  }

  if (control.type === "radio") {
    if (!control.element.checked) {
      control.element.checked = true;

      control.element.dispatchEvent(
        new Event("change", {
          bubbles: true
        })
      );
    }

    return;
  }

  if (control.type === "select") {
    if (
      control.element.value !==
      control.option.value
    ) {
      control.element.value =
        control.option.value;

      control.element.dispatchEvent(
        new Event("change", {
          bubbles: true
        })
      );
    }
  }
}

    /* ==========================================================
       VALIDATION
    ========================================================== */

    validateServices() {
      /*
       * ========================================================
       * PERSONALIZATION
       * ========================================================
       */

      if (
        this.personalizationToggle?.checked
      ) {
        const value =
          this.personalizationText?.value
            .trim();

        if (!value) {
         this.showError(
  this.dataset.errorPersonalization
);

          this.personalizationText?.focus();

          return false;
        }
      }

      /*
       * ========================================================
       * TASSEL
       * ========================================================
       */

      if (
        this.tasselToggle?.checked
      ) {
        const selectedColor =
          this.querySelector(
            "[data-tassel-color]:checked"
          );

        if (!selectedColor) {
          this.showError(
  this.dataset.errorTasselColor
);

          this.querySelector(
            "[data-tassel-color]"
          )?.focus();

          return false;
        }
      }

      this.clearError();

      return true;
    }

    /* ==========================================================
       SUBMIT
    ========================================================== */

    handleSubmit(event) {
      /*
       * Ми більше НЕ додаємо товари вручну.
       *
       * Prestige сам виконає Add to cart.
       *
       * Нам потрібно тільки:
       * 1. перевірити поля;
       * 2. переконатися, що технічний variant
       *    уже вибраний;
       * 3. додати properties у product form.
       */

      if (!this.validateServices()) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        return;
      }

      /*
       * На випадок, якщо option ще не встигла
       * синхронізуватися.
       */
      this.syncServiceOption();

      /*
       * Перед submit створюємо properties.
       */
      this.updateLineItemProperties();
    }

    /* ==========================================================
       LINE ITEM PROPERTIES
    ========================================================== */

    updateLineItemProperties() {
      if (!this.form) {
        return;
      }

      /*
       * Спочатку видаляємо наші старі hidden inputs,
       * щоб при повторному submit не було дублів.
       */
      this.form
        .querySelectorAll(
          "[data-custom-service-property]"
        )
        .forEach((input) => input.remove());

      /*
       * ========================================================
       * PERSONALIZATION
       * ========================================================
       */

      if (
  this.personalizationToggle?.checked
) {
  this.addProperty(
    this.dataset.propertyPersonalization,
    this.dataset.valueYes
  );

  this.addProperty(
    this.dataset.propertyPersonalizationText,
    this.personalizationText?.value
      .trim() || ""
  );
}

/*
 * ========================================================
 * TASSEL
 * ========================================================
 */

if (
  this.tasselToggle?.checked
) {
  const selectedColor =
    this.querySelector(
      "[data-tassel-color]:checked"
    );

  this.addProperty(
    this.dataset.propertyTassel,
    this.dataset.valueYes
  );

  if (selectedColor) {
    this.addProperty(
      this.dataset.propertyTasselColor,
      selectedColor.value
    );
  }
}
    }

    addProperty(name, value) {
      if (
        !name ||
        value === undefined ||
        value === null ||
        value === ""
      ) {
        return;
      }

      const input =
        document.createElement("input");

      input.type = "hidden";

      input.name =
        `properties[${name}]`;

      input.value = value;

      input.dataset.customServiceProperty =
        "true";

      this.form.appendChild(input);
    }

    /* ==========================================================
       ERRORS
    ========================================================== */

    showError(message) {
      const error =
        this.querySelector(
          "[data-services-error]"
        );

      if (!error) {
        return;
      }

      error.textContent = message;
      error.hidden = false;

      error.scrollIntoView({
        behavior: "smooth",
        block: "nearest"
      });
    }

    clearError() {
      const error =
        this.querySelector(
          "[data-services-error]"
        );

      if (!error) {
        return;
      }

      error.textContent = "";
      error.hidden = true;
    }
  }

  if (
    !customElements.get(
      "custom-product-services"
    )
  ) {
    customElements.define(
      "custom-product-services",
      CustomProductServices
    );
  }
})();